

const updateUser=(val)=>{
    return {
        type:"UpdateUser",
        payload:val
    }
}
export default updateUser;